/*jshint esversion: 6 */

class SelectorTools {
    constructor(selectors) {
        for (let key in selectors) {
            this[key] = selectors[key];
        }
    }
    append (which, classNames) {
        if (this[which]) {
            this[which] = this[which] + ' ' + classNames;
        }
    }
    addSelector (key, selector) {
        this[key] = selector;
    }
}

export default SelectorTools;
